import React from "react";
import { useTranslation } from "react-i18next";

import type { OrderQuery } from "~/graphql/graphql-new.gen";
import { OrderTagReturn } from "~/graphql/graphql-new.gen";

import { OrderReturnBadge } from "./order-return-badge";
import { TrackingViewLink } from "./tracking-view-link";

export type OrderReturnProps = {
  orderReturn?: OrderQuery["order"]["returns"][number];
  tags: OrderQuery["order"]["tags"];
};

export const OrderReturn: React.FC<OrderReturnProps> = ({
  orderReturn,
  tags,
}: OrderReturnProps) => {
  const { t } = useTranslation();

  if (!orderReturn || tags.return[0] === OrderTagReturn.None) return null;

  return (
    <div className="rounded border border-gray-300">
      <div className="flex items-center justify-between border-b border-gray-300 px-6 py-4">
        <OrderReturnBadge tag={tags.return[0] ?? OrderTagReturn.None} />
      </div>
      {orderReturn.claimId ? (
        <p className="mt-4 px-6 text-sm font-semibold text-gray-900">
          {t("order.return.coming_from_a_claim")}
        </p>
      ) : null}
      <div className="space-y-4 p-6 pt-4">
        {tags.return[0] === OrderTagReturn.Delivered ? (
          <span className="text-sm text-gray-900">
            {t("order.return.return_problem_contact_us")}
          </span>
        ) : null}

        <TrackingViewLink
          parcel={{
            trackingCourier: {
              name: orderReturn.tracking.courier.name,
              logoUrl: orderReturn.tracking.courier.logoUrl,
              slug: orderReturn.tracking.courier.slug,
            },
            trackingNumber: orderReturn.tracking.number,
            trackingStatus: orderReturn.tracking.status,
            trackingUrl: orderReturn.tracking.url,
          }}
        />
      </div>
    </div>
  );
};
